export default __webpack_public_path__ + "static/media/atom-icon.3ba2a8a3.png";